import axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios'

import { env } from '@maxus/website/constants'

import { getValidAccessToken } from './auth-token'

/**
 * Axios 实例配置
 *
 * Sentry 的 browserTracingIntegration 会自动为 axios 请求添加
 * sentry-trace 和 baggage headers，实现分布式追踪。
 *
 * 无需手动配置，只要请求的 URL 匹配 tracePropagationTargets 即可。
 */

// 创建 axios 实例
export const httpClient = axios.create({
  baseURL: env.VITE_BASE_URL,
  timeout: 30000, // 30 秒超时
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
httpClient.interceptors.request.use(
  async config => {
    const token = await getValidAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// 响应拦截器
httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  },
)

// 导出类型
export type { AxiosRequestConfig, AxiosResponse, AxiosError }
